// VERSION global variable is defined in webpack config file
export default angular.module('contants.version', [])
	.constant('VersionConst', VERSION)
	.name;



// WEBPACK FOOTER //
// ./project/constants/version.js